import { string, object, number, date, mixed } from 'yup';

import { VipTaskItemTypesEnum, VipTaskItemUserIdentifierTypesEnum, YUP_ERRORS_MESSAGES } from '@shared/constants';

export const vipTaskItemValidationSchema = object().shape({
  title: string().trim().required(YUP_ERRORS_MESSAGES.REQUIRED),
  description: string().trim().required(YUP_ERRORS_MESSAGES.REQUIRED),
  type: mixed().oneOf(Object.values(VipTaskItemTypesEnum)).required(YUP_ERRORS_MESSAGES.REQUIRED),
  reward: number().required(YUP_ERRORS_MESSAGES.REQUIRED),
  order: number().required(YUP_ERRORS_MESSAGES.REQUIRED),
  userIdentifierType: mixed().oneOf(Object.values(VipTaskItemUserIdentifierTypesEnum)),
  completedTasksCount: number(),
  joinedTournamentsCount: number(),
  joinedTournamentsStartDate: date(),
});
